import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Col, Modal, Spinner2, Text } from 'components';
import { theme } from 'lib';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { CardInput } from './';

const stripe = loadStripe(process.env.REACT_APP_STRIPE_PK);

const SpinnerContaier = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  z-index: 5;
  background-color: rgba(53, 62, 74, 0.8);
`;

const AddCardWeb = ({ visible, closeModal }) => {
  const [last4, setLast4] = useState(''),
    [loading, setLoading] = useState(false),
    [exp, setExp] = useState(['', '']),
    dispatch = useDispatch(),
    { t } = useTranslation();

  return (
    <React.Fragment>
      <Modal visible={visible} closeModal={!loading && closeModal}>
        {loading && (
          <SpinnerContaier id="spinner">
            <Col centerAll ht="100%">
              <Spinner2 col={theme.SECONDARY} />
            </Col>
          </SpinnerContaier>
        )}

        <Col center ht="100%" pos="relative">
          <Col pad="32px 90px 32px 32px" center>
            <Text h1 marg="0 0 40px">
              {t('billing.addPaymentMethod')}
            </Text>
            <Elements stripe={stripe}>
              <CardInput closeModal={closeModal} loading={loading} setLoading={setLoading} />
            </Elements>
          </Col>
        </Col>
      </Modal>
    </React.Fragment>
  );
};

export default AddCardWeb;
